export const build = { date:"2026-06-30.1119", stage:"alpha" }
